export const lightTheme = {
    body: '#fafafa',
    text: '#141E29',
    heading: '#000F1E'
};
export const darkTheme = {
    body: '#000f1e',
    text: '#FAFAFA',
    heading: '#FAFAFA'
};
